// NIGHT-DIRECTSTAFF-2026-10-25 §3: "Start from an approved template" -- the five by name (lib/templates.js), the ones this box
// cannot fill shown off with what they need; picking one fills the message (and the subject in the Email box) with the merges
// applied, and the preview shows exactly what goes. Where the copy came from (the sites commit and sha256) is said.
import React, { useMemo, useState } from 'react';
import { templatesFor, sourceLabel, unresolved } from './lib/templates';

const sel = { minHeight: 44, fontSize: 13, width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box' };

/** ctx: lib/templates.js templatesFor's context; channel 'send' | 'email'; onPick({ subject, body, id }); preview: the text now */
export default function TemplatePicker({ ctx, channel = 'send', onPick, preview = '', subject = '' }) {
  const list = useMemo(() => templatesFor(ctx, channel), [ctx, channel]);
  const [id, setId] = useState('');
  const t = list.find((x) => x.id === id);
  const left = unresolved(`${subject}\n${preview}`);
  return (
    <div data-testid="tpl" style={{ display: 'grid', gap: 6, margin: '8px 0', minWidth: 0 }}>
      <label htmlFor={`tpl-${channel}`} style={{ fontSize: 11, fontWeight: 700, color: '#475569' }}>Start from an approved template</label>
      <select id={`tpl-${channel}`} data-testid="tpl-select" value={id} style={sel}
        onChange={(e) => { const x = list.find((y) => y.id === e.target.value); setId(e.target.value); if (x && x.ready) onPick({ ...x.build(), id: x.id }); }}>
        <option value="">Choose a template…</option>
        {list.map((x) => <option key={x.id} value={x.id} disabled={!x.ready}>{x.name}{x.ready ? '' : ' (not here)'}</option>)}
      </select>
      <p data-testid="tpl-source" style={{ fontSize: 11.5, color: '#475569', margin: 0, overflowWrap: 'anywhere' }}>{t ? `${t.name}: ${t.from}` : sourceLabel()}</p>
      {list.some((x) => !x.ready) && (
        <details style={{ fontSize: 11.5, color: '#475569' }}>
          <summary style={{ cursor: 'pointer', minHeight: 44, display: 'flex', alignItems: 'center' }}>Why some are off here</summary>
          <ul style={{ margin: 0, paddingLeft: 18 }}>{list.filter((x) => !x.ready).map((x) => <li key={x.id}>{x.name}: {x.why}</li>)}</ul>
        </details>)}
      {t && (
        <div data-testid="tpl-preview" style={{ background: 'white', border: '1px solid #cbd5e1', borderRadius: 8, padding: 8, fontSize: 12.5, color: '#0f172a', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: '#475569', marginBottom: 4 }}>Preview: exactly what goes</div>
          {subject ? <div><b>Subject:</b> {subject}</div> : null}{preview}
        </div>)}
      {left.length > 0 && <p data-testid="tpl-unfilled" role="alert" style={{ fontSize: 12, color: '#b91c1c', margin: 0 }}>Fill these before sending: {left.join(', ')}</p>}
    </div>
  );
}
